import { dataMember, required, typedArray } from 'santee-dcts';

export type CategoryNaturalKey = 'general-document' |
                                 'application-training' |
                                 'study-manuals' |
                                 'site-communications' |
                                 'sponsor-communications' |
                                 'sponsor-communications-e-learning' |
                                 'sponsor-communications-main' |
                                 'kit-inventory-expiration' |
                                 'lab-manuals' |
                                 'general-manuals' |
                                 'general-communications' |
                                 'general-training-materials' |
                                 'site-actions' |
                                 'lab-manuals-others' |
                                 'synopsis' |
                                 'training-materials-e-learning' |
                                 'training-materials-others' |
                                 'training-materials' |
                                 'packaging-and-shipping' |
                                 'specimen-collection' |
                                 'quick-reference-guide' |
                                 'regulatory-documents' |
                                 'general-information' |
                                 'result-alerts' |
                                 'lab-reports' |
                                 'equery' |
                                 'equery-summary' |
                                 'cancellation' |
                                 'data-revisions' |
                                 'email-notification' |
                                 'sample-report' |
                                 'sample-tracking' ;

export class Category {

    @dataMember()
    @required()
    public categoryId: CategoryNaturalKey;

    @dataMember()
    @required()
    public name: string;

    @dataMember()
    @required()
    public icon: string;

    @dataMember()
    @required()
    public canCombineForPrinting: boolean;

    @dataMember()
    @required()
    @typedArray(Category)
    public children: Category[];

    public parent: Category;

    public isLabReport(): boolean {
        return this.categoryId === 'lab-reports';
    }

    public isSiteActions(): boolean {
        return this.categoryId === 'site-actions';
    }

    public toString() {
        return this.name;
    }

    public static isELearningCategory(categoryId: CategoryNaturalKey): boolean {
        return categoryId === 'training-materials-e-learning' || categoryId === 'sponsor-communications-e-learning';
    }

    public static isTrainingMaterialsELearning(categoryId: CategoryNaturalKey): boolean {
        return categoryId === 'training-materials-e-learning';
    }

    public static isSynopsis(categoryId: CategoryNaturalKey): boolean {
        return categoryId === 'synopsis';
    }

    public static isTrainingMaterialsOthers(categoryId: CategoryNaturalKey): boolean {
        return categoryId === 'training-materials-others'; 
    }

    public static isLabManualsOthers(categoryId: CategoryNaturalKey): boolean {
        return categoryId === 'lab-manuals-others';
    }
}
